{
  "errorBoundary": {
    "title": "Algo falló en esta pantalla",
    "description": "Haz una captura de esta pantalla y envíala. Los detalles técnicos de abajo indican exactamente dónde ocurrió.",
    "stack": "Componente / stack",
    "reload": "Recargar",
    "goHome": "Volver al inicio"
  },
  "auth": {
    "poweredBy": "Desarrollado por <brand>Xtreed</brand>"
  },
  "student": {
    "collapseMenu": "Contraer menú",
    "expandMenu": "Expandir menú",
    "openMenu": "Abrir menú",
    "defaultLevel": "Principiante",
    "xp": "{{value}} XP",
    "menu": "Menú",
    "nav": {
      "home": "Inicio",
      "courses": "Cursos",
      "ranking": "Ranking",
      "community": "Comunidad",
      "certificates": "Certificados",
      "profile": "Perfil"
    },
    "comingSoon": "Próximamente",
    "logout": "Cerrar sesión",
    "welcome": "<muted>Bienvenido de nuevo,</muted> <name>{{name}}</name>",
    "admin": "Admin",
    "lightMode": "Modo claro",
    "darkMode": "Modo oscuro",
    "myProfile": "Mi perfil"
  },
  "admin": {
    "badge": "Admin",
    "groups": {
      "overview": "Visión general",
      "content": "Contenido",
      "commercial": "Comercial",
      "community": "Comunidad",
      "platform": "Plataforma"
    },
    "nav": {
      "dashboard": "Panel",
      "courses": "Cursos",
      "modules": "Módulos",
      "videos": "Videos",
      "categories": "Categorías",
      "certificates": "Certificados",
      "accessGroups": "Grupos de acceso",
      "members": "Miembros",
      "customFields": "Campos del perfil",
      "surveys": "Encuestas",
      "gamification": "Gamificación",
      "videoUsage": "Uso de video",
      "settings": "Configuración"
    },
    "closeMenu": "Cerrar menú",
    "collapseMenu": "Contraer menú",
    "expandMenu": "Expandir menú",
    "openMenu": "Abrir menú",
    "backToApp": "Volver a la app",
    "logout": "Cerrar sesión",
    "panelTitle": "Panel de administración",
    "online": "En línea",
    "assistant": {
      "open": "Abrir asistente",
      "close": "Contraer asistente",
      "banner": {
        "title": "Conoce al Asistente Xtreed",
        "subtitle": "Crea cursos, módulos y lecciones por ti, escribe descripciones y lo publica todo en tu área de miembros. Solo conversa.",
        "dontShowAgain": "No volver a mostrar",
        "close": "Cerrar",
        "seeNow": "Verlo ahora"
      }
    }
  }
}
